// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : react hooks for widgets
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import {get, dict} from 'ldash'
import log from 'uix/logging'
import {useSelector, useEffect, useActions, useMemo, useState} from 'uix/hooks'
import {useSimpleSearch} from 'uix/modules/search/hooks'
import {hashObj} from 'uix/utils'

// ---Exports
export const useWidgetData = otids => {
  /* retrieve page info and caption of first ancestor md
   */
  let wdata = useSelector(root => root.data.widget.bibData)
  let [loading, setLoading] = useState({})
  let loadWidgetData = useActions(Actions.loadWidgetData)

  useEffect(() => {
    let missing = otids.filter(otid => !wdata[otid] && !loading[otid])
    if (missing.length > 0) {
      loadWidgetData(missing)
      setLoading({...loading, ...dict(otids.map(otid => [otid, true]))})
    }
  }, [hashObj(otids)]) // probably not needed due to "loading" tracking

  let filteredData = useMemo(
    () => dict(otids.filter(otid => wdata[otid]).map(otid => [otid, wdata[otid]])),
    [wdata]
  )

  return filteredData
}

export const useSearch = query => {
  let itypes = useSelector(root => root.config.instance.itypes)
  let select = [
    'odid',
    'datatype',
    'subtype',
    'caption',
    'oc.date',
    'octp.ot_id',
    'octp.imgwidth',
    'octp.imgheight',
  ]

  let sr = useSimpleSearch({query, select})

  let data = useMemo(() => {
    if (sr && sr.rows) {
      return sr.rows.map(row => ({
        odid: row.odid,
        type: itypes.byId[row.datatype][row.subtype],
        title: row.caption,
        date: row.oc_date,
        pageId: row.octp_ot_id,
        pageWidth: row.octp_imgwidth,
        pageHeight: row.octp_imgheight,
      }))
    }
    return []
  }, [sr])
  return data
}
